export function setTableData(state, payload) {
    state.items.data = payload.data;
    state.items.pagination = payload.pagination;
    state.items.filter = payload.filter;
}
export function setAvgCalc(state, payload) {
    console.log('payload', payload)
    state.avg_calc.Avg_Coach_rating = payload.Avg_Coach_rating;
    state.avg_calc.Avg_Session = payload.Avg_Session;
    state.avg_calc.Avg_shift = payload.Avg_shift;
    state.avg_calc.length = payload.length;
}